// Official LOOXS logo. NEVER redrawn or regenerated. Served from the backend
// static bucket so it lives with the codebase. Ships with a proper alpha channel
// so it blends smoothly on ANY background — no CSS blend modes needed.
const BASE = process.env.REACT_APP_BACKEND_URL;
export const LOOXS_LOGO_URL = `${BASE}/api/static/brand/looxs-wordmark.png`;

export default function LooxsLogo({ height = 44, className = "", tone = "auto" }) {
  // Kept the `tone` prop for backwards-compat but it's now a no-op — the PNG has
  // clean transparency, so it drops onto cream or onyx backgrounds identically.
  return (
    <img
      src={LOOXS_LOGO_URL}
      alt="LOOXS — Fashion from London, crafted in India"
      className={className}
      style={{ height, width: "auto", display: "block" }}
      draggable="false"
    />
  );
}
